import { Ability } from '@casl/ability';
import { useSelector } from 'react-redux';

import { AppState } from '../../../Configs/store/AppReducer';

//* Remarques : il n'y a pas d'actions spécifiques liées à des permissions dans DETAM
//* cette method n'est pas utile dans DETAM

export const useMePermissions = (): Ability => {
    const ability = useSelector((state: AppState): Ability => state.Me.ability);
    return ability
}